import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import MaintenanceLogo from '../img/maintenance.svg'
import React from 'react'

const Maintenance = () => {
    const { t } = useTranslation()

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', textAlign: 'center', p: 2 }}>
            <img src={MaintenanceLogo} alt="Maintenance" width="128" height="128" />
            <Typography variant="h2" component="h2" gutterBottom>
                {t('maintenance.title')}
            </Typography>
            <Typography variant="body1" component="p" gutterBottom>
                {t('maintenance.description')}
            </Typography>
        </Box>
    )
}

export default Maintenance
